
export const EsimPriceApiStatus = Object.freeze({
  Provider1428RelatedError: 'Provider1428RelatedError',
  NotBelongToOrg: 'NotBelongToOrg',
  BelongToDifferentOrg: 'BelongToDifferentOrg',
  GeneralError: 'GeneralError',
  SuspendedTheftOrLoss: 'SuspendedTheftOrLoss',
  Suspended: 'Suspended',
  Provider835RelatedError: 'Provider835RelatedError',
  NoError: 'NoError',
});
export const EsimUpgradeEligibilityApiStatus = Object.freeze({
  NoError: 'NoError',
  GeneralError: 'GeneralError',
  SubscriberIsAbroad: 'SubscriberIsAbroad',
  SubscriberIsInNiudProcess: 'SubscriberIsInNiudProcess',
});

export const EsimUpgradePages = Object.freeze({
  WelcomePage: 'WelcomePage',
  ChoseEsimOrSim: 'ChoseEsimOrSim',
  ChangeToEsim: 'ChangeToEsim',
  ChangeToEsimSuccess: 'ChangeToEsimSuccess',
  NotBelongToOrg: 'NotBelongToOrg',
  BelongToDifferentOrg: 'BelongToDifferentOrg',
  Suspended: 'Suspended',
  SubscriberIsAbroad: 'SubscriberIsAbroad',
  SubscriberIsInNiudProcess: 'SubscriberIsInNiudProcess',
  Provider1428RelatedError: 'Provider1428RelatedError',
  Provider835RelatedError: 'Provider835RelatedError',
  GeneralError: 'GeneralError',
  BusinessClientSimChangeComponent: 'BusinessClientSimChangeComponent',
});

export const InnerPopupTypes = Object.freeze({
  NoPopup: 'NoPopup',
  EsimInformation: 'EsimInformation',
  SupportedDevices: 'SupportedDevices',
  CancelSuspensionConditions: 'CancelSuspensionConditions',
  SuspendedTheftOrLoss: 'SuspendedTheftOrLoss',
});

export const DispRsnTypes = Object.freeze({
  SubscriberIsActive: '00A',
  SuspendedTheftOrLoss: '00L',
});

